import { render } from "./BrowserFrame.vue?vue&type=template&id=3c4cb8aa"
import script from "./BrowserFrame.vue?vue&type=script&lang=js"
export * from "./BrowserFrame.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__